__turbopack_context__.v({
  "link": "footer-section-module__5uNu4a__link",
});
